import type { Services } from '@wix/app-market-services';
import { Placement } from '@wix/app-market-services';
import type { DynamicSectionType } from './types';
import {
  completeSetupCountId,
  fallbackSidebarSections,
  getDynamicSidebarItemsId,
  sidebarComponentId,
} from './sidebar-constants';
import { fetchWithQuery } from '@wix/app-market-core';
import type { QueryClient } from '@tanstack/react-query';
import type { MarketWatch } from '@wix/app-market-watch';

export async function getDynamicSidebarItems({
  services,
  queryClient,
  marketWatch,
  isMetaSiteId,
}: {
  services: Services;
  queryClient: QueryClient;
  marketWatch: MarketWatch;
  isMetaSiteId: boolean;
}): Promise<DynamicSectionType[]> {
  try {
    const { sections } = await fetchWithQuery({
      queryClient,
      queryFn: () =>
        services.appMarketClientAggregator.getDynamicSections({
          placement: Placement.SIDEBAR,
          isMetaSiteId,
        }),
      queryKey: getDynamicSidebarItemsId,
    });

    return sections ?? [];
  } catch (e) {
    const error = new Error(
      '[sidebar-api.ts] (getDynamicSidebarItems) failed: ',
      {
        cause: e,
      },
    );
    marketWatch.monitor(sidebarComponentId).reportError(error);
    return fallbackSidebarSections;
  }
}

export async function getCompleteSetupCount({
  services,
  queryClient,
  marketWatch,
}: {
  services: Services;
  queryClient: QueryClient;
  marketWatch: MarketWatch;
}): Promise<number> {
  try {
    return fetchWithQuery({
      queryClient,
      queryFn: () =>
        services.completeSetupCount({
          hideWixApps: false,
          includeOldBundles: false,
          includeAppBenefits: true,
        }),
      queryKey: completeSetupCountId,
    });
  } catch (e) {
    const error = new Error(
      '[sidebar-api.ts] (getCompleteSetupCount) failed: ',
      {
        cause: e,
      },
    );
    marketWatch.monitor(sidebarComponentId).reportError(error);
    return 0;
  }
}
